import {ValueObject} from '@s-ui/domain'

import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'
import {FilterIdsArraySearchValueObject} from './FilterIdsArraySearchValueObject.js'

export class FilterProvinceIdsSearchValueObject extends ValueObject {
  #provinceIds

  constructor({provinceIds}) {
    super()
    this.#provinceIds = provinceIds
  }

  static create({provinceIds}) {
    return new FilterProvinceIdsSearchValueObject({provinceIds: FilterIdsArraySearchValueObject.create(provinceIds)})
  }

  static createWithDefaultValue({config, provinceIds}) {
    const {DEFAULT_PROVINCE_IDS_SEARCH} = config.get('searchFilters')

    return new FilterProvinceIdsSearchValueObject({
      provinceIds: FilterIdsArraySearchValueObject.createForNumbers({value: provinceIds ?? DEFAULT_PROVINCE_IDS_SEARCH})
    })
  }

  static createQueryParams({config, provinceIds}) {
    const {DEFAULT_PROVINCE_IDS_SEARCH, FILTER_NAMES, FILTER_QUERY_PARAMS} = config.get('searchFilters')

    return new FilterProvinceIdsSearchValueObject({
      provinceIds: QueryParamSharedValueObject.createForPipeArray({
        key: FILTER_QUERY_PARAMS[FILTER_NAMES.PROVINCE],
        value: (provinceIds ?? DEFAULT_PROVINCE_IDS_SEARCH).filter(Boolean)
      })
    })
  }

  get isEmpty() {
    return this.#provinceIds.isEmpty
  }

  get queryParams() {
    return {
      ...(!this.isEmpty && {...this.#provinceIds.queryParam})
    }
  }

  get value() {
    return this.#provinceIds.value
  }

  toJSON() {
    return {
      provinceIds: this.#provinceIds.toJSON()
    }
  }
}
